import { render } from "./Header.vue?vue&type=template&id=b210cf9e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=b210cf9e&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Tepparad\\Tepparad-benefit-newver\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b210cf9e"]])

export default __exports__